import React from "react";
import { bodyLabel } from "app/Components/BodyPartComponent/CONSTANT";
import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { permitShifts } from "./IncidentReportForm";
import moment from "moment";
import { isBefore } from "app/_helpers/dateHelper";
import { GiReturnArrow } from "react-icons/gi";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const notApplicable = "Not Applicable";

// ------- DO NOT CHANGE ORDER OF KEY-VALUE PAIR ----------
// ------- DO NOT CHANGE ORDER OF KEY-VALUE PAIR ----------
// ------- DO NOT CHANGE ORDER OF KEY-VALUE PAIR ----------
// ------- DO NOT CHANGE ORDER OF KEY-VALUE PAIR ----------

export const staffType = {
  employee: "Employee",
  contractor: "Contractor",
  others: "Visitor",
};

export const GETVAL = {
  employee: "employee",
  contractor: "contractor",
  others: "others",
  Others: "Others",
  omc: "omc",
};

export const STAFFEMPLOYER = [
  { id: "omc", contactPerson: "OMC" },
  { id: "others", contactPerson: "Visitor" },
  { id: "Others", contactPerson: "Others" },
];

export const GENERAL_REASONS = [
  { id: "fireInvolved", generalReasons: "Fire Involved" },
  { id: "inundation", generalReasons: "Inundation" },
  { id: "fallOfObject", generalReasons: "Fall Of Object" },
  { id: "facilityOutage", generalReasons: "Facility Outage" },
  { id: "permanentDisability", generalReasons: "Permanent Disability" },
  { id: "facilityShutdown", generalReasons: "Facility Shutdown" },
  { id: "explosion", generalReasons: "Explosion" },
  { id: "longDurationFire", generalReasons: "Long Duration Fire" },
  { id: "equipmentFailure", generalReasons: "Equipment Failure" },
  { id: "alcoholViolator", generalReasons: "Alcohol Violator" },
  { id: "ppeViolator", generalReasons: "PPE Violator" },
  { id: "unfitBuyerTruck", generalReasons: "Unfit Buyer Truck" },
  { id: "unfitHEMM", generalReasons: "Unfit HEMM" },
];

export const injuryOutcomes = {
  notApplicable: "N/A",
  fatality: "Fatality",
  noLostTime: "No Lost Time",
  lostTime: "Lost Time",
  notSure: "Not Sure",
};

export const capaSources = [
  "Key Risk Indicator",
  "Incident Management",
  "LAQ",
  "Drilling",
  "Civil",
  "HF & Completions",
  "Workover",
  "Audits & Meetings",
  "Compliance Register",
  "Training",
  "Production Operations",
  "Sales & Metering",
  "Regulatory",
  "G&G",
  "Material & Resources",
  "Corporate",
  "Others",
  "Not Applicable",
];

export const capaStatuses = {
  open: "Open",
  closed: "closed",
  overdue: "OverDue",
  completed: "Completed",
  due: "due",
};
export const incidentStatuses = {
  draft: "Draft",
  open: "Reported",
  mmReview: "MM Review",

  investigationProgress: "Investigation Inprogress",
  investigationOverDue: "Investigation OverDue",
  investigationReturned: "Returned Investigation",
  investigationCompleted: "Investigation Completed",
  investigationReviewed: "Investigation Reviewed",

  capaAssigned: "CAPA Assigned",
  CapaOverDue: "CAPA OverDue",
  CapaReturned: "CAPA Returned",
  capaCompleted: "CAPA Completed",
  // capaCompleted2: "Capa Completed",
  capaReviewed: "CAPA Reviewed",

  closed: "Closed",
};

export const INVESTIGATION_STATUS = {
  completed: "completed",
};

export const incidentStatusesPermission = {
  investigation: "investigator",
  finalReview: "reviewer",
  closed: "closer",
};

export const INCIDENTTYPESEVERITY_4_5 = [
  "lti",
  "seriousBInjury",
  "fatality",
  "unsafeAct",
  "unsafeCondition",
  "nearMiss",
  "mti",
];

export const RO_CLOSED_INCIDENT_TYPE = ["unsafeAct", "unsafeCondition", "mti"];

export const incidentTypes = {
  unsafeAct: "Unsafe Act",
  unsafeCondition: "Unsafe Condition",
  nearMiss: "Near Miss",
  mti: "MTI (Medical Treatment Injury)",
  lti: "LTI (Lost Time Injury)",
  seriousBInjury: "Serious bodily injury",
  fatality: "Fatality",
};
export const checkLtiWithType = ["mti", "lti", "seriousBInjury"];
export const incidentByArea = {
  21: "21",
  22: "22",
};
export const incidentBySubArea = {
  999: "999",
  28: "28",
  27: "27",
  26: "26",
  25: "25",
};
export const incidentBySubActivity = {
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
};
export const incidentByActivity = {
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
};
export const incidentByDepartment = {
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
};
export const incidentByShift = {
  I: "I",
  II: "II",
  III: "III",
};
export const incidentByInvolving = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
};
export const incidentOnThreeHoursIntervals = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
};
export const incidentByInjuryBody = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
};
export const incidentByInjuryType = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
};
export const incidentByStaffType = {
  others: "others",
  employee: "employee",
  contractor: "contractor",
};
export const outstandingCAPAsAreaOwnerWise = {
  451: "451",
};

// Need to remove its dependency
export const severities = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
};

export const highSeverities = [
  {
    value: "1",
    label: "1",
    tooltip:
      "Improper placement/Improper position/Disorderly workplace/Poor house keeping",
  },
  {
    value: "2",
    label: "2",
    tooltip: "Not using PPEs/Using improper tools or equipment/Space congestion",
  },
  {
    value: "3",
    label: "3",
    tooltip: "Violation of rules/ regulation/ SOPs/Codes & Procedures",
  },
  {
    value: "4",
    label: "4",
    tooltip: "Serious hazard - injury or potential to cause injury if not corrected",
  },
  {
    value: "5",
    label: "5",
    tooltip:
      "Urgent danger- serious injury or fatality or potentiality to cause serious injury or fatality if not corrected",
  },
];

export const lowSeverities = [
  {
    value: "1",
    label: "1",
    tooltip:
      "Improper placement/Improper position/Disorderly workplace/Poor house keeping",
  },
  {
    value: "2",
    label: "2",
    tooltip: "Not using PPEs/Using improper tools or equipment/Space congestion",
  },
  {
    value: "3",
    label: "3",
    tooltip: "Violation of rules/ regulation/ SOPs/Codes & Procedures",
  },
];

export const capaPriorities = {
  low: "Low",
  medium: "Medium",
  high: "High",
};
export const commentTypes = {
  investigation: "Investigation",
  review: "Review",
  closure: "Closure",
};
export const evidenceTypes = {
  photo: "Photo",
  video: "Video",
  // audio: "Audio",
  document: "Document",
};
export const evidenceTypesObj = {
  photo: "Photo",
  document: "Document",
};
export const evidenceCategories = {
  report: "Report",
  investigation: "Investigation",
  review: "Review",
  closure: "Closure",
  investigationOther: "InvestigationOther",
};
export const trainingNeed = {
  recommended: "Recommended",
  mandatory: "Mandatory",
  // optional: "Optional",
};
export const complianceObservations = {
  followed: "Followed",
  notFollowed: "Not Followed",
};

export const initialForm = {
  id: null,
  incidentId: "",
  type: "",
  incidentDate: "",
  reportDate: "",
  siteId: "",
  functionData: "",
  severity: "",
  severityPostReview: "",
  fireInvolved: false,
  facilityOutage: false,
  permanentDisability: false,
  facilityShutdown: false,
  explosion: false,
  longDurationFire: false,
  equipmentFailure: false,
  fallOfObject: false,
  inundation: false,
  indirectLosses: "",
  facilityStatus: "",
  similarIncidentHappened: "",
  summary: "",
  description: "",
  measuresOrActions: "",
  fatalityEmployees: "",
  fatalityContractors: "",
  fatalityOthers: "",
  injuredEmployees: "",
  injuredContractors: "",
  injuredOthers: "",
  lostManhoursEmployees: "",
  lostManhoursContractors: "",
  lostManhoursOthers: "",
  peopleCount: "",
  isPersonalInjury: null,
  isAssetIncident: null,
  injuryInfoRequired: null,
  isVehicleIncident: null,
  isSpillsIncident: null,
  reportEvidencesRequired: null,
  stateMasterId: "",
  countryMasterId: "",
  departmentId: "",
  workAreaId: "",
  shift: "",
  directIncidentLoss: "",
  directIncidentLossToEquipment: false,
  insuranceClaimRaised: false,
  insuranceClaimAmount: "",
  insuranceApprovedAmount: "",
  insuranceUnapprovedAmount: "",
  rootCause: "",
  rootCauseOther: "",

  cause: ["", notApplicable],
  fireCause: ["", notApplicable],
  couldAvoidBy: [""],
  avoidable: "No",
  environmentalImpact: "No",
  environmentalAssessment: "",
  solutionType: "",
  insuranceApplicable: null,
  complianceRequired: null,
  witnessStatementRequired: null,
  rootCauseAnalysisRequired: null,
  capaRequired: null,
  trainingRequired: null,
  solutionRequired: null,
  evidencesRequired: null,
  reviewEvidencesRequired: null,
  insuranceFileId: null,
  investigationCompletionSummary: "",
  reviewCompletionSummary: "",
  closureCompletionSummary: "",
  investigationCompletionDate: null,
  reviewCompletionDate: null,
  closureCompletionDate: null,
  incidentStatus: incidentStatuses.draft,
  investigationCompleted: false,
  reviewCompleted: false,
  closureCompleted: false,
  areaId: "",
  roId: "",
  staffType: "",
  staffEmployer: "",
  staffName: "",
  subAreaId: "",
  // otherSubArea: "",
  activityId: "",
  subActivityId: "",
  reportAtLabel: "ro",
  closeIncident: false,
  isInvestigation: false,
  investigationLeader: "",
  investigationStatus: incidentStatuses.draft,
  investigationDetails: {},
  otherSubArea: "",
  otherStaffName: "",
  ownerId: "",
  targetCompletionDate: null,
  locationSiteId: "",
  roSiteId: "",
  otherDocumentRequired: null,
  causeIndirect: "",
  causeIndirectOther: "",
  causeImmediate: "",
  causeImmediateOther: "",
  alcoholViolator: false,
  ppeViolator: false,
  unfitBuyerTruck: false,
  unfitHEMM: false,
};

export const initialPersonalDetails = {
  type: "Employee",
  name: "",
  phone: "",
  age: "",
  injuryType: notApplicable,
  severity: Object.keys(severities)[0],
  bodyParts: notApplicable,
  outcome: notApplicable,
  ltiHours: 0,
  userId: null,
  employer: "omc",
};

export const initialAssetDetails = {
  sku: "",
  name: "",
  details: "",
  damage: "No",
};

export const initialVehicleDetails = {
  number: "",
  type: "LMV",
  owner: "Company",
  driverName: "",
  observation: "",
  insuranceStatus: "Comprehensive",
};

export const initialSpill = {
  location: "",
  workAreaId: "",
  fluid: "",
  indicativeVolume: "",
  cause: "",
  response: "",
};

export const incidentCauses = {
  notApplicable,
  deviation: "Deviation from Procedure",
  lackOfJobKnowledge: "Lack of Job Knowledge",
  lackOfSuperVision: "Lack of supervision",
  improperInspection: "Improper Inspection",
  improperMaintenance: "Improper Maintenance. (Mech. / Elec. / Inst.)",
  improperMaterialHandling: "Improper material handling",
  negligentDriving: "Negligent Driving",
  carelessWalking: "Careless walking / climbing etc.",
  notUsingPpe: "Not using the PPE ",
  equipmentFailure: "Equipment failure",
  poorDesign: "Poor design / Layout etc.",
  inadequateFacility: "Inadequate facility",
  poorHouseKeeping: "Poor House Keeping",
  naturalCalamity: "Natural Calamity",
  pilferageSabotage: "Pilferage / Sabotage",
  other: "Other",
};

export const incidentFireCauses = {
  notApplicable,
  nearHotWork: "Near to Hot Work",
  nearFurnace: "Near to Furnace / Flare etc.",
  autoIgnition: "Auto Ignition",
  looseElectricalConnection: "Loose Electrical Connection",
  nearHotSurface: "Near to hot surface",
  other: "Other",
};

export const reasonsToAvoid = {
  notApplicable,
  betterSuperVision: "Better supervision",
  adheringOperatingProcedure: "Adhering to specified operating procedure",
  impartingTraining: "Imparting Training",
  properPlanning: "Giving adequate time to do the activity through proper planning.",
  adheringWorkPermitSystem: "Adhering to the work permit system",
  personalProtective: "Personal Protective Equipment",
  betterEqupment: "Better equipment",
  managementControl: "Management Control",
  adheringMaintainance: "Adhering to specified maintenance procedure",
  adheringInspectionProcedures: "Adhering to Specified Inspection / Testing procedures.",
  safeDriving: "Any other: Safe driving.",
  other: "Other",
};

export const initialCompliance = {
  incidentDetailsId: null,
  name: "",
  remarks: "",
  observation: Object.keys(complianceObservations)[0],
};

export const initialTraining = {
  incidentDetailsId: null,
  name: "",
  need: Object.keys(trainingNeed)[0],
  categoryId: "",
};

export const initialWitnessStatement = {
  incidentDetailsId: null,
  name: "",
  date: "",
  description: "",
};

export const initialMitigationMeasure = {
  incidentDetailsId: null,
  value: "",
};

export const initialRootCauseDescription = {
  incidentDetailsId: null,
  value: "",
};

export const initialIndirectCause = {
  incidentDetailsId: null,
  value: "",
};

export const initialImmediateCause = {
  incidentDetailsId: null,
  value: "",
};

export const initialSolution = {
  incidentDetailsId: null,
  value: "",
};

export const initialCapa = {
  incidentDetailsId: null,
  capaId: "",
  source: "Incident Management",
  solution: "",
  priority: "high",
  actionsOrResolutions: "",
  dueDate: "",
  completionDate: null,
  capaStatus: "Open",
  ownerId: null,
  departmentId: null,
  completionProofId: null,
  siteId: null,
  workAreaId: null,
  areaId: null,
  subAreaId: null,
  capaType: null,
  otherSubArea: "",
};
export const initialEmailTemplateForm = {
  emailTemplate: "",
  dynamicVariables: {},
  event: "",
  subject: "",
  // notificationMessageToUser: "",
  escalateGroupTo: "",
  escalateCC: "",
  notificationMessage: "",
};

export const initialEvidence = {
  incidentDetailsId: null,
  id: null,
  type: Object.keys(evidenceTypes)[0],
  description: "",
  file: null,
  fileId: null,
};

export const initialOtherDocuments = {
  incidentDetailsId: null,
  id: null,
  type: "Document",
  description: "",
  file: null,
  fileId: null,
};

// --------------------------- RULES ------------------------------

export const incidentReviewRules = [
  // {
  //   field_name: "severityPostReview",
  //   label: "Severity Post Review",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "reviewCompletionDate",
    label: "Completion Date",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "reviewCompletionSummary",
    label: "Summary",
    type: "string",
    isRequired: true,
  },
];

export const incidentClosureRules = [
  {
    field_name: "closureCompletionSummary",
    label: "Summary",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "closureCompletionDate",
    label: "Completion Date",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "investigationLeader",
    label: "Investigation Leader",
    type: "string",
    isRequired: true,
  },
];

export const staffNameRule = {
  field_name: "staffName",
  label: "Staff Name",
  type: "string",
  isRequired: true,
  tab: 1,
};

export const otherstaffNameRule = {
  field_name: "otherStaffName",
  label: "Other Staff Name",
  type: "string",
  isRequired: true,
  tab: 1,
};
export const otherSubAreaValidation = {
  field_name: "otherSubArea",
  label: "Other Sub Area",
  type: "string",
  isRequired: true,
  tab: 1,
};

export const incidentReportRules = [
  {
    field_name: "type",
    label: "Type",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "severity",
    label: "Incident Severity",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "incidentDate",
    label: "Incident Date",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "reportDate",
    label: "Report Date",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "siteType",
    label: "Site Name",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "siteId",
    label: "Site",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "staffType",
    label: "Staff Type",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "staffEmployer",
    label: "Staff Employer",
    type: "String",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "indirectLosses",
    label: "Indirect Losses",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "facilityStatus",
    label: "Facility Status",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "similarIncidentHappened",
    label: "Similar Incident Happened",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "summary",
    label: "Summary",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "description",
    label: "Description",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "measuresOrActions",
    label: "Measures or Actions",
    type: "string",
    isRequired: true,
    tab: 2,
  },
  {
    field_name: "stateMasterId",
    label: "State",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "countryMasterId",
    label: "Country",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "departmentId",
    label: "Department",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "areaId",
    label: "Work Area",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "subAreaId",
    label: "Work Sub Area",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "shift",
    label: "Shift",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "activityId",
    label: "Activity",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "subActivityId",
    label: "Sub Activity",
    type: "string",
    isRequired: true,
    tab: 1,
  },
  {
    field_name: "peopleCount",
    label: "People Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "fatalityEmployees",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "fatalityContractors",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "fatalityOthers",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "injuredEmployees",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "injuredContractors",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "injuredOthers",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "lostManhoursEmployees",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "lostManhoursContractors",
    label: "Count",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "lostManhoursOthers",
    label: "Count",
    type: "number",
    isRequired: true,
  },
];

export const personalDetailsRules = [
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "phone",
  //   label: "Phone",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "age",
    label: "Age",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "ltiHours",
    label: "LTI Hours",
    type: "number",
    isRequired: true,
  },
];

export const assetDetailsRules = [
  {
    field_name: "sku",
    label: "SKU",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "details",
    label: "Details",
    type: "string",
    isRequired: true,
  },
];

export const vehicleDetailsRules = [
  {
    field_name: "number",
    label: "Number",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "driverName",
    label: "Driver Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "observation",
    label: "Observation",
    type: "string",
    isRequired: true,
  },
];

export const spillsRules = [
  {
    field_name: "location",
    label: "Location",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "workAreaId",
    label: "Work Area",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "fluid",
    label: "Fluid",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "indicativeVolume",
    label: "Indicative Volume",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "cause",
    label: "Cause",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "response",
    label: "Response",
    type: "string",
    isRequired: true,
  },
];

export const investigationFormRules = [
  {
    field_name: "directIncidentLoss",
    label: "Direct Loss",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "cause",
  //   label: "Incident Cause",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "fireCause",
  //   label: "Fire Cause",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "rootCause",
  //   label: "Root Cause",
  //   type: "string",
  //   isRequired: false,
  // },
  // {
  //   field_name: "solutionType",
  //   label: "Solution Type",
  //   type: "string",
  //   isRequired: false,
  // },
  // {
  //   field_name: "indirectCause",
  //   label: "Indirect Cause",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "immediateCause",
  //   label: "Immediate Cause",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "couldAvoidBy",
  //   label: "Could Avoid By / Using",
  //   type: "string",
  //   isRequired: false,
  // },
  // {
  //   field_name: "cause",
  //   label: "Cause",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "investigationCompletionDate",
    label: "Complete Date",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "investigationCompletionSummary",
    label: "Summary",
    type: "string",
    isRequired: true,
  },
];

export const insuranceTabRules = [
  {
    field_name: "insuranceClaimAmount",
    label: "Claim Amount",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "insuranceApprovedAmount",
    label: "Claim Approved Amount",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "insuranceUnapprovedAmount",
    label: "Claim Unapproved Amount",
    type: "number",
    isRequired: true,
  },
];

export const investigationTabRules = [
  {
    field_name: "couldAvoidBy",
    label: "Minimum one checkbox",
    type: "string",
    isRequired: true,
  },
];

export const complianceRules = [
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "remarks",
    label: "Remarks",
    type: "string",
    isRequired: true,
  },
];
export const witnessStatementRules = [
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "date",
    label: "Date",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "description",
    label: "Description",
    type: "string",
    isRequired: true,
  },
];
export const trainingRules = [
  {
    field_name: "name",
    label: "Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "categoryId",
    label: "Category",
    type: "string",
    isRequired: true,
  },
];
export const capaUpdateRules = [
  {
    field_name: "completionDate",
    label: "Completion Date",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "actionsOrResolutions",
    label: "Actions or Resolutions",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "capaStatus",
    label: "Final Status",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "siteId",
    label: "Site Name",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "workAreaId",
  //   label: "Source Area",
  //   type: "string",
  //   isRequired: true,
  // },
];
export const capaRoRules = [
  // Validation Section Start Here By Aman
  {
    field_name: "capaType",
    label: "CAPA Type",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "areaId",
    label: "Area",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "subAreaId",
    label: "SubArea",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "ownerId",
    label: "Owner",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "solution",
    label: "Description",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "priority",
    label: "Priority",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "otherSubArea",
    label: "Other Sub Area",
    type: "string",
    isRequired: false,
  },
];
export const capaRules = [
  // Validation Section Start Here By Aman
  {
    field_name: "capaType",
    label: "CAPA Type",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "solution",
    label: "Description",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "areaId",
    label: "Area",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "subAreaId",
    label: "SubArea",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "ownerId",
    label: "Owner",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "priority",
    label: "Priority",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "dueDate",
    label: "Due Date",
    type: "string",
    isRequired: true,
  },

  // Validation Section Ends Here By Aman

  // {
  //   field_name: "source",
  //   label: "Source",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "solution",
  //   label: "Solution / Description",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "priority",
  //   label: "Priority",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "dueDate",
  //   label: "Due Date",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "ownerId",
  //   label: "Owner",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "departmentId",
  //   label: "Department",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "workAreaId",
  //   label: "Work Area",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "otherSubArea",
    label: "Other Sub Area",
    type: "string",
    isRequired: false,
  },
];

export const mitigationMeasureRules = [
  {
    field_name: "value",
    label: "This Field",
    type: "string",
    isRequired: true,
  },
];
export const rootCauseDescriptionRules = [
  {
    field_name: "value",
    label: "This Field",
    type: "string",
    isRequired: true,
  },
];
export const solutionRules = [
  {
    field_name: "value",
    label: "This Field",
    type: "string",
    isRequired: true,
  },
];
export const evidenceRules = [
  {
    field_name: "description",
    label: "Description",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "fileId",
    label: "File",
    type: "string",
    isRequired: true,
  },
];

export const getIncidentStatusClass = (status, isInvestigationRevert = 0, form) => {
  switch (status) {
    case incidentStatuses.draft:
      return "bg-dark text-white rounded text-center px-2";
    case "Returned":
      return "bg-dark text-white rounded text-center px-2";
    case incidentStatuses.open:
      return "notstarted";
    case incidentStatuses.initialReview:
      return "pending";
    case incidentStatuses.investigationProgress:
      return checkInvestigatorOverDue(form?.investigationDetails?.targetCompletionDate)
        ? "notstarted"
        : "orange text-white rounded text-center";
    case incidentStatuses.mmReview:
      return isInvestigationRevert !== 1
        ? "notstarted"
        : "bg-primary text-white rounded text-center px-1";
    case incidentStatuses.investigationReviewed:
      return "green-300 text-white rounded text-center";
    case incidentStatuses.investigationCompleted:
      return "green-300 text-white rounded text-center";
    case incidentStatuses.capaAssigned:
      return checkCapaReturned(form?.capas)
        ? "bg-primary text-white rounded text-center px-1"
        : checkCapaOverDue(form?.capas)
        ? "notstarted"
        : "yellow text-white rounded text-center";
    case incidentStatuses.capaReviewed:
      return "orange text-white rounded text-center";

    case incidentStatuses.capaCompleted:
      return "green-300 text-white rounded text-center";
    case incidentStatuses.capaCompleted2:
      return "green-300 text-white rounded text-center";

    case incidentStatuses.finalReview:
      return "bg-primary text-white rounded text-center px-1";

    case incidentStatuses.closed:
      return "success";
    default:
      return "notstarted";
  }
};

export const getIncidentSeverityClass = (severity) => {
  switch (severities[severity]) {
    case severities[1]:
      return "severityOne";
    case severities[2]:
      return "severityTwo";
    case severities[3]:
      return "severityThree";
    case severities[4]:
      return "severityFour";
    default:
      return "notstarted";
  }
};

export const yesNoOptions = {
  0: "No",
  1: "Yes",
};

export const incidentFilterFields = [
  {
    name: "staffType",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(staffType).map((k) => ({
      label: staffType[k],
      value: k,
    })),
  },
  {
    name: "staffEmployer",
    title: "Staff Employer",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: STAFFEMPLOYER.map((r) => ({ label: r.contactPerson, value: r.id })),
  },
  {
    name: "name",
    title: "Name",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "type",
    title: "Incident Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(incidentTypes).map((k) => ({
      label: incidentTypes[k],
      value: k,
    })),
  },
  {
    name: "severity",
    title: "Severity",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(severities).map((k) => ({
      label: severities[k],
      value: k,
    })),
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "roId",
    title: "Location RO",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "areaId",
    title: "Area",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "subAreaId",
    title: "Sub Area",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "shift",
    title: "Shift",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(permitShifts).map((k) => ({
      label: permitShifts[k],
      value: permitShifts[k],
    })),
  },
  {
    name: "activityId",
    title: "Activity",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "subActivityId",
    title: "Sub Activity",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "departmentId",
    title: "Department",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "reportedBy",
    title: "Reporting Officer",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "incidentStatus",
    title: "Incident Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(incidentStatuses).map((k) => ({
      label: incidentStatuses[k],
      value: incidentStatuses[k],
    })),
  },
  {
    name: "bodyParts",
    title: "Body Parts",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(bodyLabel).map((k) => ({
      label: bodyLabel[k],
      value: k,
    })),
  },
  {
    name: "injuryOutcome",
    title: "Injury Outcome",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(injuryOutcomes).map((k) => ({
      label: injuryOutcomes[k],
      value: k,
    })),
  },
  {
    name: "generalReasonsFilter",
    title: "General-Info Reasons",
    inputType: EFormFieldInputTypes.multiSelect,
    options: GENERAL_REASONS.map((r) => ({ label: r.generalReasons, value: r.id })),
  },
  {
    name: "ltiHoursUpdate",
    title: "LTI Information updated",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(yesNoOptions).map((r) => ({
      label: yesNoOptions[r],
      value: r,
    })),
  },
  {
    name: "reportEvidencesRequired",
    title: "Evidence",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(yesNoOptions).map((r) => ({
      label: yesNoOptions[r],
      value: r,
    })),
  },
];

export const validateRowFilter = (filterForm, row) => {
  for (const key in filterForm) {
    if (
      (!filterForm[key] && key !== "contractorInvolved") ||
      key === "startDate" ||
      key === "endDate" ||
      key === "taskOwnerId" ||
      key === "imRole" ||
      key === "vflRole" ||
      key === "medicalRole" ||
      key === "ohseRole" ||
      key === "formARole" ||
      key === "trainingRole" ||
      key === "injuryOutcome" ||
      key === "bodyParts" ||
      key === "incidentStatus" ||
      key === "vflStatus" ||
      key === "siteIdEmp" ||
      key === "capaStatus" ||
      key === "ltiHoursUpdate" ||
      key === "reportEvidencesRequired" ||
      [
        "fireInvolved",
        "inundation",
        "fallOfObject",
        "facilityOutage",
        "permanentDisability",
        "facilityShutdown",
        "explosion",
        "longDurationFire",
        "equipmentFailure",
        "alcoholViolator",
        "ppeViolator",
        "unfitBuyerTruck",
        "unfitHEMM",
        "generalReasonsFilter",
      ].includes(key)
    )
      continue;
    console.log(
      "/*/**/validateRowFilterfilterForm",
      row[key],
      filterForm[key],
      // row[key] !== filterForm[key],
      filterForm
      // row
    );
    // if (key === "roId" && filterForm[key]) {
    //   console.log("qq", filterForm[key]);
    //   console.log("qq", row?.siteData?.id);
    //   if (filterForm[key] !== row?.siteData?.id) return false;
    // }
    if (!filterForm[key] && key === "contractorInvolved") continue;
    if (key === "name")
      return row.createdByData?.firstName
        ?.toLowerCase()
        ?.includes(filterForm[key].toLowerCase());
    else if (row[key] !== filterForm[key]) return false;
  }

  return true;
};

export const FORM_LABEL_OFFICER = {
  so: "Safety Officer",
  mm: "Mines Manager",
  ro: "Reporting Officer",
};

export const CURRENT_SEVERITY = (row) => {
  return row?.severityPostReview || row?.severity;
};

export const TAB_STATUS_COUNT = (tableData, status) => {
  return tableData?.filter((data) => {
    return checkStatusByFilter(status, data);
  }).length;
};

export const INCIDENT_STATUS_VIEW = (status, isRevert, isBack, form) => {
  return (
    <>
      <div className={getIncidentStatusClass(status, isRevert, form)}>
        {isRevert !== 1 ? (
          isBack ? (
            <span>
              {status}
              <GiReturnArrow className="ml-2" size={18} />
            </span>
          ) : status !== incidentStatuses?.investigationProgress &&
            status !== incidentStatuses?.capaAssigned ? (
            status
          ) : status === incidentStatuses?.investigationProgress &&
            checkInvestigatorOverDue(form?.investigationDetails?.targetCompletionDate) ? (
            incidentStatuses?.investigationOverDue
          ) : status === incidentStatuses?.capaAssigned ? (
            checkCapaReturned(form?.capas) ? (
              <span>
                {incidentStatuses?.CapaReturned}
                <GiReturnArrow className="ml-2" size={18} />
              </span>
            ) : checkCapaOverDue(form?.capas) ? (
              incidentStatuses?.CapaOverDue
            ) : (
              status
            )
          ) : (
            status
          )
        ) : (
          <span>
            {incidentStatuses?.investigationReturned}
            <GiReturnArrow className="ml-2" size={18} />
          </span>
        )}
      </div>
    </>
  );
};

export const checkInvestigatorOverDue = (date) => {
  const currentDate = moment().format("YYYY-MM-DD");
  return isBefore(moment(date).format("YYYY-MM-DD"), currentDate);
};

export const checkCapaReturned = (data) => {
  const findReturned = data?.find((d) => d?.reverted) || "";
  return findReturned ? true : false;
};

export const checkCapaOverDue = (data) => {
  const findOverDue = data?.find((d) => d?.capaStatus === "OverDue") || "";
  return findOverDue ? true : false;
};

export const getReturnRecord = (activeReturn, setActiveReturn = () => {}) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-top"> Return View</Tooltip>}
    >
      <a
        href
        className={`icons pointer ${activeReturn ? "text-cyanBlue" : "text-muted"}`}
        onClick={() => setActiveReturn(!activeReturn)}
      >
        <GiReturnArrow className="ml-2" size={18} />
      </a>
    </OverlayTrigger>
  );
};

export const checkStatusByFilter = (status, data) => {
  let flag = false;
  if (
    status === incidentStatuses?.investigationReturned &&
    data?.investigationDetails?.reverted
  )
    flag = true;
  else if (
    status === incidentStatuses?.investigationOverDue &&
    data.incidentStatus === incidentStatuses?.investigationProgress &&
    checkInvestigatorOverDue(data?.investigationDetails?.targetCompletionDate)
  )
    flag = true;
  else if (
    status === incidentStatuses?.investigationProgress &&
    data.incidentStatus === status &&
    !checkInvestigatorOverDue(data?.investigationDetails?.targetCompletionDate)
  )
    flag = true;
  else if (
    status === incidentStatuses?.mmReview &&
    data.incidentStatus === status &&
    !data?.investigationDetails?.reverted
  )
    flag = true;
  else if (
    status === incidentStatuses?.CapaReturned &&
    data.incidentStatus === incidentStatuses?.capaAssigned &&
    checkCapaReturned(data?.capas)
  )
    flag = true;
  else if (
    status === incidentStatuses?.CapaOverDue &&
    data.incidentStatus === incidentStatuses?.capaAssigned &&
    checkCapaOverDue(data?.capas) &&
    !checkCapaReturned(data?.capas)
  )
    flag = true;
  else if (
    status === incidentStatuses?.capaAssigned &&
    data.incidentStatus === status &&
    !checkCapaReturned(data?.capas) &&
    !checkCapaOverDue(data?.capas)
  )
    flag = true;
  else if (
    status !== incidentStatuses?.investigationProgress &&
    status !== incidentStatuses?.mmReview &&
    status !== incidentStatuses?.capaAssigned &&
    data.incidentStatus === status
  )
    flag = true;

  return flag;
};

export const capaFilterFields = [
  {
    name: "capaStatus",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Completed", value: "Completed" },
      { label: "Over Due", value: "OverDue" },
      { label: "Open", value: "Open" },
      { label: "Returned", value: "revert" },
    ],
  },
  {
    name: "source",
    title: "Source Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Incident", value: "Incident Management" },
      { label: "VFL", value: "ehs_vfl_observations" },
    ],
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
];

export const ltiFormRules = [
  {
    field_name: "ltiHours",
    label: "LTI Hours",
    type: "number",
    isRequired: true,
  },
];

export const OUTCOME_NOT_LTI = ["unsafeAct", "unsafeCondition", "nearMiss"];
export const OUTCOME_OPTIONAL_LTI = ["seriousBInjury", "mti"];
export const PERSONNEL_ONE_ROW = ["seriousBInjury", "mti", "fatality", "lti"];

export const isExistLti = (personData) => {
  return !!personData?.find((d) => d.outcome === "lostTime" && !d.deleted);
};

export const isExistFatality = (personData) => {
  return !!personData?.find((d) => d.outcome === "fatality" && !d.deleted);
};

export const MANADATORY_PERSONNEL_ONE_ROW = (form, personData) => {
  return !!(
    PERSONNEL_ONE_ROW.includes(form?.type) &&
    (!form?.isPersonalInjury || !personData?.filter((d) => !d?.deleted)?.length)
  );
};

export const CHECK_NO_HAVE_LTI = (form, personData) => {
  return !!(
    form?.isPersonalInjury &&
    OUTCOME_NOT_LTI.includes(form?.type) &&
    isExistLti(personData)
  );
};

export const CHECK_MANADATORY_LTI = (form, personData) => {
  return !!(form?.type === "lti" && !isExistLti(personData));
};

export const CHECK_MANADATORY_FATALITY = (form, personData) => {
  return !!(form?.type === "fatality" && !isExistFatality(personData));
};

export const CHECK_OPTIONAL_LTI = (form, personData) => {
  return !!(OUTCOME_OPTIONAL_LTI.includes(form?.type) && !isExistLti(personData));
};

export const GET_MSSG_WITH_VALIDATE_LTI_FATALITY = (
  form,
  personData,
  setIsOptionalPopup
) => {
  setIsOptionalPopup(false);
  console.log("checkkkkkkk", form, personData);
  if (MANADATORY_PERSONNEL_ONE_ROW(form, personData))
    return `Incident type selected is ${
      incidentTypes[form?.type]
    }. At least one person should be included in personnel details section.`;
  else if (CHECK_NO_HAVE_LTI(form, personData))
    return `Please select appropriate Incident Type in Incident Info Tab. A ${
      incidentTypes[form?.type]
    } can not have LTI as an outcome.`;
  else if (CHECK_MANADATORY_LTI(form, personData))
    return `At least one person should have LTI as an outcome as selected incident type is LTI.`;
  else if (CHECK_MANADATORY_FATALITY(form, personData))
    return "At least one person should have fatality as an outcome as selected incident type is fatality.";
  else if (CHECK_OPTIONAL_LTI(form, personData)) {
    setIsOptionalPopup(true);
    return `You have selected incident type as ${
      incidentTypes[form?.type]
    }. However no LTI information has been entered. Is it correct?`;
  } else return "";
};

export const progressWithIncidentStatus = [incidentStatuses.open, incidentStatuses.draft];
